// Import types
import type { TranslationMessages } from './types';

// Re-export for backward compatibility
export type { TranslationMessages } from './types';

// Basic English messages (simplified from ra-language-english)
const englishMessages: TranslationMessages = {
  ra: {
    action: {
      add: 'Add',
      add_filter: 'Add filter',
      back: 'Back',
      bulk_actions: '1 item selected |||| %{smart_count} items selected',
      cancel: 'Cancel',
      clear_array_input: 'Clear the list',
      clear_input_value: 'Clear value',
      clone: 'Clone',
      confirm: 'Confirm',
      create: 'Create',
      create_item: 'Create %{item}',
      delete: 'Delete',
      edit: 'Edit',
      export: 'Export',
      list: 'List',
      refresh: 'Refresh',
      remove_filter: 'Remove this filter',
      remove: 'Remove',
      save: 'Save',
      search: 'Search',
      select_all: 'Select all',
      select_row: 'Select this row',
      show: 'Show',
      sort: 'Sort',
      undo: 'Undo',
      unselect: 'Unselect',
      expand: 'Expand',
      close: 'Close',
      open_menu: 'Open menu',
      close_menu: 'Close menu',
    },
    auth: {
      auth_check_error: 'Please login to continue',
      logout: 'Logout',
      user_menu: 'Profile',
      username: 'Username',
      password: 'Password',
      sign_in: 'Sign in',
      sign_in_error: 'Authentication failed, please retry',
      logout_title: 'Logout',
    },
    page: {
      list: '%{name}',
      edit: '%{name} #%{id}',
      show: '%{name} #%{id}',
      create: 'Create %{name}',
      delete: 'Delete %{name} #%{id}',
      dashboard: 'Dashboard',
      not_found: 'Not Found',
      loading: 'Loading',
    },
    input: {
      file: {
        upload_several: 'Drop some files to upload, or click to select one.',
        upload_single: 'Drop a file to upload, or click to select it.',
      },
      image: {
        upload_several: 'Drop some pictures to upload, or click to select one.',
        upload_single: 'Drop a picture to upload, or click to select it.',
      },
      references: {
        all_missing: 'Unable to find references for this field.',
        many_missing:
          'At least one of the associated references no longer appears to be available.',
        single_missing:
          'Associated reference no longer appears to be available.',
      },
    },
    message: {
      about: 'About',
      are_you_sure: 'Are you sure?',
      bulk_delete_content:
        'Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?',
      bulk_delete_title: 'Delete %{name} |||| Delete %{smart_count} %{name}',
      delete_content: 'Are you sure you want to delete this item?',
      delete_title: 'Delete %{name} #%{id}',
      details: 'Details',
      error: "A client error occurred and your request couldn't be completed.",
      invalid_form: 'The form is not valid. Please check for errors',
      loading: 'The page is loading, please wait a moment',
      no: 'No',
      not_found: 'Either you typed a wrong URL, or you followed a bad link.',
      yes: 'Yes',
    },
    navigation: {
      no_results: 'No results found',
      no_more_results:
        'The page number %{page} is out of boundaries. Try the previous page.',
      page_out_of_boundaries: 'Page number %{page} out of boundaries',
      page_out_from_end: 'Cannot go after last page',
      page_out_from_start: 'Cannot go before page 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
      page_rows_per_page: 'Rows per page:',
      next: 'Next',
      prev: 'Prev',
    },
    sort: {
      sort_by: 'Sort by %{field} %{order}',
      ASC: 'ascending',
      DESC: 'descending',
    },
  },
};

// Import separate translation files
import { common } from './common';
import { pos } from './pos';
import { notifications } from './notifications';
import { richTextUltra } from './richTextUltra';
import { bugReport } from './bugReport';
import { support } from './support';
import { faq } from './faq';
import { assistant } from './assistant';
import { version } from './version';

// Combine all translations
const customEnglishMessages: TranslationMessages = {
  ...englishMessages,
  common,
  pos,
  notifications,
  richTextUltra,
  bugReport,
  support,
  faq,
  assistant,
  version,
};

export default customEnglishMessages;
